export const UPSERT_BOOKABLE_EVENT_MUTATION = `
  mutation UpsertBookableEvent(
    $id: ID,
    $startsAt: String!,
    $endsAt: String!,
    $allDay: Boolean,
    $timeZone: String!,
    $bookableEventTypeId: ID!,
    $recurrencePattern: String,
    $isProgram: Boolean,
    $paymentTiming: String
  ) {
    upsertBookableEvent(
      id: $id,
      startsAt: $startsAt,
      endsAt: $endsAt,
      allDay: $allDay,
      timeZone: $timeZone,
      bookableEventTypeId: $bookableEventTypeId,
      recurrencePattern: $recurrencePattern,
      isProgram: $isProgram,
      paymentTiming: $paymentTiming
    ) {
      result
      errors
      bookableEvent {
        id 
        startsAt
        endsAt
        allDay
        timeZone
        bookableEventTypeId
        bookableEventSeriesId
        name
        description
        instructions 
        capacity
        amountCents
        amountCurrency 
        location 
        kind
        bookableEventType {
          id
          name
          duration
          durationUnit
          capacity
          amountCents
          amountCurrency
          location
          kind
        }
        bookableEventSeries {
          id
          sessionCount
          paymentTiming
        }
      }
      bookableEventSeries {
        id
        sessionCount
        paymentTiming
        formattedScheduleSummary
      }
      bookableEvents {
        id 
        startsAt
        endsAt
        allDay
        timeZone
        bookableEventTypeId
        name
        description
        instructions 
        capacity
        amountCents
        amountCurrency 
        location 
        kind
        bookableEventType {
          id
          name
          duration
          durationUnit
          capacity
          amountCents
          amountCurrency
          location
          kind
        }
      }
    }
  }
`

export const UPDATE_BOOKABLE_EVENT_PHOTO_MUTATION = `
  mutation UpdateBookableEventPhoto($handle: String!, $id: ID!) {
    updateBookableEventPhoto(handle: $handle, id: $id) { result errors photoUrl }
  }
`

export const REMOVE_BOOKABLE_EVENT_PHOTO_MUTATION = `
  mutation RemoveBookableEventPhoto($id: ID!) {
    removeBookableEventPhoto(id: $id) { result errors }
  }
`

export const DELETE_BOOKABLE_EVENT_MUTATION = `
  mutation DeleteBookableEvent($id: ID!) {
    deleteBookableEvent(id: $id) { result errors }
  }
`

export const ADD_CLIENT_TO_BOOKABLE_EVENT_MUTATION = `
  mutation AddClientToBookableEvent(
    $bookableEventId: ID!
    $clientId: ID
    $clientParams: ClientInput
    $amountCents: Int
  ) {
    addClientToBookableEvent(
      bookableEventId: $bookableEventId
      clientId: $clientId
      clientParams: $clientParams
      amountCents: $amountCents
    ) {
      result
      errors
      registrationsCount
      paymentResult
      registration {
        id
        amountCents
        paymentStatus
        bookedBy
        markPaid
        client {
          id
          firstName
          lastName
          email
          phone
        }
      }
    }
  }
`

export const UPDATE_BOOKABLE_EVENT_REGISTRATION_AMOUNT_MUTATION = `
  mutation UpdateBookableEventRegistrationAmount(
    $bookableEventId: ID!
    $clientId: ID!
    $amountCents: Int!
  ) {
    updateBookableEventRegistrationAmount(
      bookableEventId: $bookableEventId
      clientId: $clientId
      amountCents: $amountCents
    ) {
      result
      errors
      bookableEventRegistration {
        id
        amountCents
        paymentStatus
      }
    }
  }
`

export const REMOVE_CLIENT_FROM_BOOKABLE_EVENT_MUTATION = `
  mutation RemoveClientFromBookableEvent($bookableEventId: ID!, $clientId: ID!) {
    removeClientFromBookableEvent(bookableEventId: $bookableEventId, clientId: $clientId) {
      result
      errors
      registrationsCount
    }
  }
`

export const ADD_CLIENT_TO_BOOKABLE_EVENT_SERIES_MUTATION = `
  mutation AddClientToBookableEventSeries(
    $bookableEventSeriesId: ID!
    $clientId: ID
    $clientParams: ClientInput
    $amountCents: Int
  ) {
    addClientToBookableEventSeries(
      bookableEventSeriesId: $bookableEventSeriesId
      clientId: $clientId
      clientParams: $clientParams
      amountCents: $amountCents
    ) {
      result
      errors
      registrationsCount
      paymentResult
      registration {
        id
        amountCents
        paymentStatus
        bookedBy
        markPaid
        client {
          id
          firstName
          lastName
          email
          phone
        }
      }
    }
  }
`

export const REMOVE_CLIENT_FROM_BOOKABLE_EVENT_SERIES_MUTATION = `
  mutation RemoveClientFromBookableEventSeries($bookableEventSeriesId: ID!, $clientId: ID!) {
    removeClientFromBookableEventSeries(bookableEventSeriesId: $bookableEventSeriesId, clientId: $clientId) {
      result
      errors
      registrationsCount
    }
  }
`

export const PROCESS_REGISTRATION_PAYMENT_MUTATION = `
  mutation ProcessRegistrationPayment($registrationId: ID!) {
    processRegistrationPayment(registrationId: $registrationId) {
      result
      errors
    }
  }
`

export const PROCESS_SERIES_REGISTRATION_PAYMENT_MUTATION = `
  mutation ProcessSeriesRegistrationPayment($registrationId: ID!) {
    processSeriesRegistrationPayment(registrationId: $registrationId) {
      result
      errors
    }
  }
`

export const UPDATE_BOOKABLE_EVENT_SERIES_REGISTRATION_AMOUNT_MUTATION = `
  mutation UpdateBookableEventSeriesRegistrationAmount(
    $bookableEventSeriesId: ID!
    $clientId: ID!
    $amountCents: Int!
  ) {
    updateBookableEventSeriesRegistrationAmount(
      bookableEventSeriesId: $bookableEventSeriesId
      clientId: $clientId
      amountCents: $amountCents
    ) {
      result
      errors
      bookableEventSeriesRegistration {
        id
        amountCents
        paymentStatus
      }
    }
  }
`

export const REQUEST_EVENT_REGISTRATION_PAYMENT_MUTATION = `
  mutation RequestEventRegistrationPayment($registrationId: ID!, $sendTo: String!) {
    requestEventRegistrationPayment(registrationId: $registrationId, sendTo: $sendTo) {
      result
      errors
    }
  }
`

export const REQUEST_EVENT_SERIES_REGISTRATION_PAYMENT_MUTATION = `
  mutation RequestEventSeriesRegistrationPayment($registrationId: ID!, $sendTo: String!) {
    requestEventSeriesRegistrationPayment(registrationId: $registrationId, sendTo: $sendTo) {
      result
      errors
    }
  }
`

export const MARK_BOOKABLE_EVENT_REGISTRATION_PAID_MUTATION = `
  mutation MarkBookableEventRegistrationPaid($registrationId: ID!, $paidBy: String) {
    markBookableEventRegistrationPaid(registrationId: $registrationId, paidBy: $paidBy) {
      result
      errors
    }
  }
`

export const UNDO_MARK_BOOKABLE_EVENT_REGISTRATION_PAID_MUTATION = `
  mutation UndoMarkBookableEventRegistrationPaid($registrationId: ID!) {
    undoMarkBookableEventRegistrationPaid(registrationId: $registrationId) {
      result
      errors
    }
  }
`

export const MARK_BOOKABLE_EVENT_SERIES_REGISTRATION_PAID_MUTATION = `
  mutation MarkBookableEventSeriesRegistrationPaid($registrationId: ID!, $paidBy: String) {
    markBookableEventSeriesRegistrationPaid(registrationId: $registrationId, paidBy: $paidBy) {
      result
      errors
    }
  }
`

export const UNDO_MARK_BOOKABLE_EVENT_SERIES_REGISTRATION_PAID_MUTATION = `
  mutation UndoMarkBookableEventSeriesRegistrationPaid($registrationId: ID!) {
    undoMarkBookableEventSeriesRegistrationPaid(registrationId: $registrationId) {
      result
      errors
    }
  }
`
